import { ReactNode } from 'react';
import { Icon, Link } from '@vp/swan';

export function HowItWorksLink({
    skin,
    children,
    setModalOpen,
}: {
    skin: 'standard' | 'unstyled';
    children: ReactNode;
    setModalOpen: (isOpen: boolean) => void;
}) {
    return (
        <Link withIcon skin={skin} onClick={() => setModalOpen(true)}>
            {children}
            <Icon iconType="helpQuery" size="16p" />
        </Link>
    );
}
